// extracted by mini-css-extract-plugin
export default {"bikeParameter":"BikeParameter_bikeParameter__+fkXd","bikeParameterHeader":"BikeParameter_bikeParameterHeader__a42tX","bikeParameterValue":"BikeParameter_bikeParameterValue__LXYIr"};